<template>
  <div class="settings-product">
    <div class="row header-row">
      <div class="col-12 col-md-6">
        <h3>My Products</h3>
      </div>
      <div class="col-12 col-md-6 text-right-md">
        <button
          type="button"
          class="btn btn-primary btn-add"
          @click="addProduct()"
        >
          <font-awesome-icon
            :icon="['fas', 'plus']"
            class="icon alt"
          />
          <span>New Product</span>
        </button>
      </div>
    </div>
    
    <div
      v-if="!items"
      class="row"
    >
      <Loader :style="{width: '100%'}" />
    </div>

    <div
      v-else-if="items.length === 0"
      class="no-results"
    >
      <p>
        You haven't added any products yet.
      </p>
    </div>

    <div v-else>
      <product-table
        :items="items"
        :view-product="viewProduct"
        :after-create-template="loadItems"
      />
      
      <pagination
        v-if="count > limit"
        :filtered-count="count"
        :page="page"
        :page-size="limit"
        :on-page-changed="onPageChanged"
      />
    </div>

    <product-modal
      ref="productModal"
      :on-product-added="onProductAdded"
    />    
  </div>
</template>

<script>
import ProductTable from '@/components/tables/ProductTable.vue';
import ProductModal from '@/components/modals/ProductModal.vue';
import Loader from '@/components/Loader.vue';
import Pagination from '@/components/Pagination.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'Components',
  components: {
    ProductTable,
    ProductModal,
    Loader,
    Pagination,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),

      items: null,

      count: 0,
      page: 1,
      limit: 50,
    };
  },
  mounted() {
    this.$store.commit('clearGlobalAlerts');
    this.loadItems();
  },
  methods: {
    loadItems() {
      this.items = null;
      const company = this.$globals.company();
      const offset = (this.page - 1) * this.limit;
      this.userClient.getCompanyProducts(company.id, this.limit, offset).then((response) => {
        this.items = response.results;
        this.count = response.count;

        this.items.forEach(i => i._company = company);
      }).catch(ex => {
        this.items = [];
        this.count = 0;
      });
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;
        this.loadItems();
      }
    },
    onProductAdded() {
      this.loadItems();
      this.$globals.refreshUser();
    },
    addProduct() {
      this.$refs.productModal.show();
    },
    async viewProduct(product) {
      try {
        const productModel = await this.userClient.getProduct(product.id);
        const features = await this.userClient.getProductFeatures(product.id);
        const answers = await this.userClient.getProductQuestions(product.id);
        
        productModel._features = features ? features.items : [];
        productModel._answers = answers ? answers.items : [];
        this.$refs.productModal.show(productModel);
      } catch(ex) {
        console.log(ex);
        this.$globals.showError('Failed to load product. Please try again.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-product {
  padding: 30px 0 75px;
  padding-left: 15px;
  padding-right: 15px;

  .header-row {
    margin-bottom: 30px;

    /deep/ .btn {
      position: relative;
      top: -8px;
    }
  }
}

.text-right-md {
  @media (min-width: $md-min) {
    text-align: right;
  }
}

.btn-add {
  i,
  svg {
    margin-right: 8px;
  }
}
</style>
